"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEADERS = exports.VERSION = exports.W3W_REGEX = void 0;
var os_1 = require("os");
var serializer_1 = require("./serializer");
exports.W3W_REGEX = /[^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]{1,}[.｡。･・︒។։။۔።।][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]{1,}[.｡。･・︒។։။۔።।][^0-9`~!@#$%^&*()+\-_=[{\]}\\|'<,.>?/";:£§º©®\s]{1,}/gi;
exports.VERSION = '4.0.6';
exports.HEADERS = {
    'X-W3W-Wrapper': typeof process === 'undefined'
        ? "what3words-JavaScript/" + exports.VERSION + " (" + window.navigator.userAgent + ")"
        : "what3words-Node/" + exports.VERSION + " (Node " + process.version + "; " + serializer_1.getPlatform(os_1.platform()) + " " + os_1.release() + ")",
};
//# sourceMappingURL=constants.js.map